<script setup>
const props = defineProps({
  imgSrc: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    required: true,
  },
  buttonText: {
    type: String,
    required: true,
  },
  buttonLink: {
    type: String,
    required: false,
    default: '#',
  },
});

</script>

<template>
  <div class="max-w-sm flex flex-col rounded max-h-full overflow-hidden shadow-lg bg-basecolor text-primary rounded-2xl">
    <img class="w-full h-72 object-cover" :src="imgSrc" alt="Imagen del componente">
    <div class="px-6 py-4 flex-grow">
      <h3 class="text-lg font-semibold mb-2">{{ title }}</h3>
      <p>
        {{ text }}
      </p>
    </div>
    <div class="px-8 pt-4 pb-2 text-center">
      <a :href="buttonLink">
        <button class=" w-full btn-cta text-sm mr-2 mb-2">
          {{ buttonText }}
        </button>
      </a>
    </div>
  </div>
</template>
